import { create } from 'zustand';
import { ICommentsAndObservations } from '../types/global';

interface ICommentsState {
  comments: ICommentsAndObservations[];
  loadingComments: boolean;
  setComments: (comments: ICommentsAndObservations[]) => void;
  setLoadingComments: (loading: boolean) => void;
  clearComments: () => void;
}

/**
 * Store general para manejar comentarios
 */
const useCommentsState = create<ICommentsState>(set => ({
  comments: [],
  loadingComments: false,
  
  setComments: (comments: ICommentsAndObservations[]) => {
    set({ comments });
  },
  setLoadingComments: (loading: boolean) => {
    set({ loadingComments: loading });
  },
  clearComments: () => {
    set({ comments: [], loadingComments: false });
  }
}));

export default useCommentsState;
